<template>
  <div class="settings">
    <h4 class="secondary-font">
      Notification Settings
    </h4>

    <div class="labels">
      <div class="email">
        Email
      </div>
      <div>Mobile</div>
    </div>

    <div class="row">
      <div class="label">
        Notify me when a watchlist price alert is triggered
      </div>

      <checkbox
        id="notificationSettingsWatchlist"
        v-model="notificationSettings.watchlist"
        class="first"
        @input="updateNotificationSettings"
      />

      <checkbox
        id="notificationSettingsWatchlistMobile"
        v-model="notificationSettings.watchlistMobile"
        class="second"
        @input="updateNotificationSettings"
      />
    </div>

    <div class="row">
      <div class="label">
        Notify me when my collection value changes
      </div>

      <checkbox
        id="notificationSettingsCollection"
        v-model="notificationSettings.collection"
        class="first"
        @input="updateNotificationSettings"
      />

      <checkbox
        id="notificationSettingsCollectionMobile"
        v-model="notificationSettings.collectionMobile"
        class="second"
        @input="updateNotificationSettings"
      />
    </div>

    <div class="row">
      <div class="label">
        Notify me when one of my sales gets approved
      </div>

      <checkbox
        id="notificationSettingsSaleApproval"
        v-model="notificationSettings.saleApproval"
        class="first"
        @input="updateNotificationSettings"
      />

      <checkbox
        id="notificationSettingsSaleApprovalMobile"
        v-model="notificationSettings.saleApprovalMobile"
        class="second"
        @input="updateNotificationSettings"
      />
    </div>

    <div class="row">
      <div class="label">
        Notify me of important updates about Card Ladder
      </div>

      <checkbox
        id="notificationSettingsDailyUpdates"
        v-model="notificationSettings.dailyUpdates"
        class="first"
        @input="updateNotificationSettings"
      />

      <checkbox
        id="notificationSettingsDailyUpdatesMobile"
        v-model="notificationSettings.dailyUpdatesMobile"
        class="second"
        @input="updateNotificationSettings"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import clone from 'lodash.clonedeep';
import * as Sentry from '@sentry/vue';

import { authService } from '@/services';

export default {
  data() {
    return {
      notificationSettings: {},
    };
  },

  created() {
    this.load();
  },

  computed: {
    ...mapState({
      user: (state) => state.user,
    }),
  },

  methods: {
    load() {
      const user = clone(this.user);

      this.notificationSettings = user.notificationSettings;
    },

    async updateNotificationSettings() {
      try {
        await authService.updateUser(this.user.uid, { notificationSettings: this.notificationSettings });
      } catch (e) {
        this.$toasted.error('Error updating your notification settings');
        Sentry.captureException(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.settings {
  @media($medium-up) {
    max-width: 640px;
  }

  h2 {
    margin-bottom: 0;
  }
}

.row {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .label {
    flex: 1;
    margin-right: $gp;
    margin-bottom: $gp;
  }

  .first {
    margin-right: 16px;
  }

  .second {
    margin-right: 5px;
  }
}

.labels {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 14px;

  .email {
    margin-right: $gp * .5;
  }
}
</style>
